(function() {
  'use strict';

  angular.module('ringbaPortal')
    .directive('trTargetGroups', function() {
      return {
        restrict: 'E',
        scope: {},
        controller: 'TargetGroupsController',
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: '/scripts/components/targetgroups/target-groups.view.html'
      };
    });
})();
